import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { IdvOutcome } from '../../enums/IdvOutcome.js';
import { IdvStatus } from '../../enums/IdvStatus.js';
import { ProofOfIdentity } from '../../enums/ProofOfIdentity.js';
import { ALPHA_CHAR_PATTERN, ALPHA_NUMERIC_WITH_UNDERSCORE_DASH, } from '../../utils/regex.js';
export class KYCResultResponse extends BaseMessage {
    id;
    individualId;
    proofOfIndentity;
    agreeToBiometricCheck;
    journeyId;
    country;
    countryCode;
    guid;
    mobileNumber;
    docUploadCaseId;
    status;
    outcome;
    message;
    createdBy;
    updatedBy;
    createdDate;
    updatedDate;
}
__decorate([
    Field.string({
        description: 'Unique Id for Idv',
        required: false,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "id", void 0);
__decorate([
    Field.string({
        description: 'Individual Id',
        required: false,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "individualId", void 0);
__decorate([
    Field.enum({
        enum: ProofOfIdentity,
        description: 'Proof Of Indentity',
        required: false,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "proofOfIndentity", void 0);
__decorate([
    Field.boolean({
        description: 'agree To Biometric Check',
        required: false,
    }),
    __metadata("design:type", Boolean)
], KYCResultResponse.prototype, "agreeToBiometricCheck", void 0);
__decorate([
    Field.string({
        description: 'Journey Id',
        required: false,
        pattern: ALPHA_NUMERIC_WITH_UNDERSCORE_DASH,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "journeyId", void 0);
__decorate([
    Field.string({
        description: 'Country',
        required: false,
        pattern: ALPHA_CHAR_PATTERN,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "country", void 0);
__decorate([
    Field.string({
        description: 'Country Code',
        required: false,
        maxLength: 3,
        minLength: 1,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "countryCode", void 0);
__decorate([
    Field.string({
        description: 'Dossier Id ',
        required: false,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "guid", void 0);
__decorate([
    Field.string({
        description: 'mobileNumber',
        required: false,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "mobileNumber", void 0);
__decorate([
    Field.string({
        description: 'docUploadCaseId',
        required: false,
        minLength: 1,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "docUploadCaseId", void 0);
__decorate([
    Field.enum({
        enum: IdvStatus,
        description: 'status',
        required: false,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "status", void 0);
__decorate([
    Field.enum({
        enum: IdvOutcome,
        description: 'outcome',
        required: false,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "outcome", void 0);
__decorate([
    Field.string({
        description: 'message',
        required: false,
        minLength: 1,
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "message", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], KYCResultResponse.prototype, "updatedBy", void 0);
__decorate([
    Field.date({
        required: false,
        description: 'created Date',
    }),
    __metadata("design:type", Date)
], KYCResultResponse.prototype, "createdDate", void 0);
__decorate([
    Field.date({
        required: false,
        description: 'updated Date',
    }),
    __metadata("design:type", Date)
], KYCResultResponse.prototype, "updatedDate", void 0);
//# sourceMappingURL=KYCResultResponse.js.map